import { render, staticRenderFns } from "./ChannelsIndicator.vue?vue&type=template&id=0302c94b&"
import script from "./ChannelsIndicator.vue?vue&type=script&lang=js&"
export * from "./ChannelsIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports